import { userModels } from '../../models/usersModels/user.module';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from '@angular/core';
import * as bcrypt from 'bcryptjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { notificationMdels } from 'src/app/models/Notifications/notification.module';
import { UserDataService } from '../user-data.service';
import { StorageService } from 'src/app/services/storage.service';


@Injectable({
  providedIn: "root"
})

export class notificationsApiService {
  private base_url = '';
  private apiUrl =  '';
  public notificationsView :any = [];
  userId:string = '';
  httpOptions: any;

  constructor(private http: HttpClient, private userData : UserDataService, private storage: StorageService) {
    this.userData.getData$()
    .subscribe((data:any)=>{
      this.userId = data.userId;
    });
   
   }

  public get(id?: number, top?: number): Observable<any> {
    this.base_url = environment.gnl_url;
    
    let userId = this.userId;
    this.apiUrl = this.base_url + 'Notificaciones';
    if (id != 0) {
      this.apiUrl = this.apiUrl + "?id=" + id + "&userId="+userId;
    }
    else if(top == 0){
      this.apiUrl = this.apiUrl + "?userId="+userId;
    }
    else if(top != 0){
     
      this.apiUrl = this.apiUrl + "?userId="+userId+"&cantidad="+top;
    }
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'token': this.storage.getInSession('api_token')
      })};
    return this.http.get<any>(this.apiUrl, this.httpOptions);

  }

  public getCount(): Observable<any> {
    this.base_url = environment.gnl_url;
    let userId = this.userId;
    this.apiUrl = this.base_url + 'Notificaciones/GetNumberNoReady?userId='+userId;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'token': this.storage.getInSession('api_token')
      })};
    return this.http.get<any>(this.apiUrl, this.httpOptions);
  }
  
  public PostRead(id: any): Observable<any> {
    let userId = this.userId;
    
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'token': this.storage.getInSession('api_token')
      })};
      var result = this.http.post<any>(environment.gnl_url+'Notificaciones/read', id , this.httpOptions);
      
    return result;
     
  }

  public Delete(id: any): Observable<any> {
    let userId = this.userId;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'token': this.storage.getInSession('api_token')
      })};
      var result = this.http.delete<any>(environment.gnl_url+'Notificaciones/delete/'+id , this.httpOptions);
      
    return result;
     
  }
  
  public Post(RequestPayload: any): Observable<any> {
    let userId = this.userId;
    RequestPayload.userId = userId;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'token': this.storage.getInSession('api_token')
      })};
    return this.http.post<any>(environment.gnl_url+'Notificaciones', RequestPayload , this.httpOptions);
  }

  obtenerNotificacionesTop10(){
    this.get(0, 99)
    .subscribe((data:any)=>{
     this.notificationsView = data.resultObject;
      return this.notificationsView;
      
    });
  }
  InsertarNotificaciones(titulo: string, descripcion: string, url: string){
    let Notification : notificationMdels = {
      titulo : titulo,
      descripcion: descripcion,
      url: url,
      estado: 0,
      userId: this.userId,
      fecha: new Date()
    };
             
    this.Post(Notification)
    .subscribe((resultData:any) =>{
      this.obtenerNotificacionesTop10();
    });
  }

  getFilter(data:any): Observable<any> {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Token': this.storage.getInSession('api_token')
      }),
      params: {strFiltro : data}};
    return this.http.get<any>(environment.gnl_url+"Notificaciones?userId="+this.userId, this.httpOptions);
  }

}
